// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBar-cls1_Tyg","cls2":"SearchBar-cls2_Vpv SearchBar-cls1_Tyg"};